import { programInfo } from '@/mocks/programData';

export default function Hero() {
  return (
    <section className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=African%20Black%20Angolan%20medical%20students%20and%20professors%20in%20white%20coats%20in%20a%20modern%20university%20lecture%20hall%2C%20diverse%20group%20of%20Black%20African%20men%20and%20women%20studying%20medicine%20together%2C%20warm%20professional%20lighting%2C%20anatomical%20models%20on%20desks%2C%20medical%20textbooks%2C%20academic%20atmosphere%20Angola%20Africa%2C%20high%20quality%20photography%20realistic&width=1920&height=800&seq=medumed-hero-angola-v3&orientation=landscape"
          alt="Educação Médica em Angola"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary/90 via-primary/80 to-primary/60" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 pt-32 md:pt-40 pb-20 md:pb-28">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/15 backdrop-blur-sm rounded-full mb-6">
            <span className="w-2 h-2 bg-accent rounded-full animate-pulse" />
            <span className="text-white/90 text-sm font-medium">
              {programInfo.edition} | {programInfo.startDate} - {programInfo.endDate}
            </span>
          </div>

          <h1 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
            Mestrado em
            <br />
            <span className="text-accent">Educação Médica</span>
          </h1>

          <p className="text-white/80 text-base md:text-lg leading-relaxed max-w-xl mb-8">
            Formação de excelência para docentes e investigadores em ciências da saúde.
            Modalidade semi-presencial em parceria com três universidades angolanas.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mb-10">
            <a
              href="https://www.cedumed.ao/medumed/Edital-Mmestrado-em-Educa%C3%A7%C3%A3o-M%C3%A9dica.pdf"
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 bg-accent text-white font-semibold rounded-lg hover:bg-accent-dark transition-colors whitespace-nowrap"
            >
              <i className="ri-download-line" />
              Baixar Edital
            </a>
            <a
              href="mailto:medumed@cedumed.ao"
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 border-2 border-white/40 text-white font-semibold rounded-lg hover:bg-white/10 transition-colors whitespace-nowrap"
            >
              <i className="ri-calendar-line" />
              Agendar Reunião
            </a>
          </div>

          <div className="flex flex-wrap gap-6 md:gap-10">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-lg bg-white/15 flex items-center justify-center">
                <i className="ri-time-line text-white text-lg" />
              </div>
              <div>
                <p className="text-white font-semibold text-sm">{programInfo.duration}</p>
                <p className="text-white/60 text-xs">Duração</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-lg bg-white/15 flex items-center justify-center">
                <i className="ri-computer-line text-white text-lg" />
              </div>
              <div>
                <p className="text-white font-semibold text-sm">{programInfo.modality}</p>
                <p className="text-white/60 text-xs">Modalidade</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-lg bg-white/15 flex items-center justify-center">
                <i className="ri-user-add-line text-white text-lg" />
              </div>
              <div>
                <p className="text-white font-semibold text-sm">{programInfo.totalVacancies} vagas</p>
                <p className="text-white/60 text-xs">Total</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-white to-transparent" />
    </section>
  );
}
